// @store-module
import { Module } from "vuex";
import { homeState, initialState } from "./state";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { actions } from "./actions";

const homeStore: Module<any, homeState> = {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};

export default homeStore;
